// extracted by mini-css-extract-plugin
module.exports = {"root":"Shipping_root__2HqxT","header":"Shipping_header__3__OU","header__switch":"Shipping_header__switch__3w3Y-","content":"Shipping_content__3Vacv"};